import PropTypes from "prop-types"
import { Button } from "@planningcenter/tapestry-react"

const CheckInsItem = ({ checkIn }) => {
  const authenticityToken = document.querySelector("head meta[name='csrf-token']").content

  return (
    <form action={checkIn.url} method="post" target="_blank" css={{ padding: 0 }}>
      <input type="hidden" name="authenticity_token" value={authenticityToken} />
      <Button
        type="submit"
        iconLeft={{ name: "logomark.checkIns", color: "rgb(135, 96, 150)" }}
        title={checkIn.name}
        size="sm"
        theme="link"
        marginVertical={0.5}
      />
    </form>
  )
}

CheckInsItem.propTypes = {
  checkIn: PropTypes.shape({
    url: PropTypes.string,
    name: PropTypes.string
  })
}

export default CheckInsItem
